import { render, staticRenderFns } from "./ops_board.vue?vue&type=template&id=a6207f0e&scoped=true&"
import script from "./ops_board.vue?vue&type=script&lang=js&"
export * from "./ops_board.vue?vue&type=script&lang=js&"
import style0 from "./ops_board.vue?vue&type=style&index=0&id=a6207f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6207f0e",
  null
  
)

export default component.exports